var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6166 1.66602H6.39163C3.56663 1.66602 1.66663 3.64935 1.66663 6.59935V13.4077C1.66663 16.3493 3.56663 18.3327 6.39163 18.3327H13.6166C16.4416 18.3327 18.3333 16.3493 18.3333 13.4077V6.59935C18.3333 3.64935 16.4416 1.66602 13.6166 1.66602Z",
    fill: "#FF5630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5129 11.4754L11.0304 9.99375L12.5121 8.51208C12.7971 8.22792 12.7971 7.76542 12.5121 7.48125C12.2271 7.19458 11.7663 7.19542 11.4813 7.48042L9.99878 8.96208L8.51628 7.47875C8.23128 7.19375 7.76961 7.19542 7.48461 7.47875C7.20044 7.76375 7.20044 8.22625 7.48461 8.51042L8.96794 9.99375L7.48794 11.4729C7.20294 11.7579 7.20294 12.2204 7.48794 12.5038C7.63044 12.6471 7.81628 12.7179 8.00294 12.7179C8.19044 12.7179 8.37628 12.6471 8.51878 12.5046L9.99878 11.0246L11.4821 12.5071C11.6246 12.6496 11.8104 12.7204 11.9971 12.7204C12.1838 12.7204 12.3704 12.6488 12.5129 12.5071C12.7979 12.2221 12.7979 11.7604 12.5129 11.4754Z",
    fill: "#FF5630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.09ed5a93.svg";
export { ForwardRef as ReactComponent };